import { createApp } from 'vue'
import App from './App.vue'
import 'ress'
import '@/assets/sass/_setting.scss'
import vueVimeoPlayer from 'vue-vimeo-player'

const app = createApp(App)
app.use(vueVimeoPlayer)
app.mount('#app')

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}